import {Dispatcher as FluxDispatcher} from 'flux';
import _ from 'lodash';

var Dispatcher = _.assign(new FluxDispatcher(), {
  handleViewAction: function (action) {
    if (!action.actionType) {
      console.error('Undefined action type: You have probably misspelled it!');
    }
    this.dispatch({
      source: 'VIEW_ACTION',
      action: action
    });
  }
});

export default Dispatcher;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/dispatcher/Dispatcher.js
 **/